import { ReactNode } from 'react';

import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';

import { IUnit, IUnitShift } from '@/models';

import { DraggableUnitContainer } from './styles';

interface DraggableUnitProps {
  unit: IUnit;
  children: ReactNode;
  disabled?: boolean;
  unitShift?: IUnitShift;
}

export const DraggableUnit = ({
  unit,
  children,
  disabled = false,
  unitShift,
}: DraggableUnitProps) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: unit._id,
      data: {
        unit,
        unitShiftId: unitShift?._id,
      },
      disabled,
    });

  const style = {
    transform: CSS.Translate.toString(transform),
  };

  return (
    <DraggableUnitContainer
      ref={setNodeRef}
      style={style}
      isDragging={isDragging}
      isDisabled={disabled}
      {...attributes}
      {...listeners}
      tabIndex={disabled ? -1 : 0}
      aria-label={`Drag unit ${unit.name}`}
      data-unit-id={unit._id}
      data-unit-shift-id={unitShift?._id}
      data-is-draggable="true"
    >
      {children}
    </DraggableUnitContainer>
  );
};
